const CELL_SELECTOR = 'input[data-rs-nav="cell"]:not(:disabled)';

type NavDirection = "right" | "left" | "down";

const focusCell = (cell: HTMLInputElement) => {
  cell.focus();
  try {
    cell.select();
  } catch {
    // type=number in some browsers does not support select()
  }
};

/**
 * Spreadsheet-style movement between result-form input boxes.
 * Tab / Shift+Tab walk left-right across enabled inputs; Enter moves down
 * to the same column on the next student row.
 */
export const moveSpreadsheetFocus = (
  current: HTMLElement,
  direction: NavDirection,
): boolean => {
  const table = current.closest("table.rs-spreadsheet-table");
  if (!table) return false;

  const cells = Array.from(
    table.querySelectorAll<HTMLInputElement>(CELL_SELECTOR),
  );
  const currentIndex = cells.indexOf(current as HTMLInputElement);
  if (currentIndex < 0) return false;

  const row = Number(current.getAttribute("data-rs-row"));
  const col = Number(current.getAttribute("data-rs-col"));

  let next: HTMLInputElement | undefined;

  if (direction === "right") {
    next = cells[currentIndex + 1];
  } else if (direction === "left") {
    next = cells[currentIndex - 1];
  } else {
    next = cells.find(
      (cell) =>
        Number(cell.getAttribute("data-rs-row")) > row &&
        Number(cell.getAttribute("data-rs-col")) === col,
    );
  }

  if (!next) return false;

  focusCell(next);
  return true;
};
